import React from 'react'
import ReactDOM from 'react-dom/client'
import { App as AntApp, ConfigProvider } from 'antd'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.jsx'
import { adminTheme } from './admin/components/adminTheme'
import 'antd/dist/reset.css'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ConfigProvider theme={adminTheme}>
      <AntApp>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </AntApp>
    </ConfigProvider>
  </React.StrictMode>
)
